import { useCallback, useEffect, useState } from 'react';
import { useSupabaseAuth } from '@/components/auth';
import { websiteUrls } from '@/lib/site-urls';
import type { Invoice } from '@/components/PaymentHistory';

export function useBillingHistory(weeksBack: number = 8) {
  const { token } = useSupabaseAuth();
  const [events, setEvents] = useState<Invoice[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    if (!token) {
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const url = new URL(websiteUrls.billing('invoices'));
      url.searchParams.set('weeks', String(weeksBack));
      const res = await fetch(url.toString(), {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = (await res.json())
      setEvents(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load billing history');
    } finally {
      setLoading(false);
    }
  }, [token, weeksBack]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { events, loading, error, refresh };
}
